module.exports = __webpack_public_path__ + "img/exit.c131f37f.svg";